import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import WebsiteService from '../../services/WebsiteService';
import PaginationComponent from '../common/PaginationComponent';
import AddWebsiteModal from '../formModal/AddWebsiteModal';

const WebsiteTable = ({loginUser}) => {
    const [websites, setWebsites] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedWebsite, setSelectedWebsite] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [totalWebsites, setTotalWebsites] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [size, setSize] = useState(10);

    useEffect(() => {
        fetchWebsites();
    }, [currentPage, size]);

    const fetchWebsites = async () => {
        try {
            setLoading(true);
            const response = await WebsiteService.getWebsites(currentPage, size);
            setWebsites(response.content || []);
            setTotalPages(response.totalPages);
            setTotalWebsites(response.totalElements);
        } catch (error) {
            toast.error(error.message || 'Failed to fetch websites.');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this website?')) return;
        try {
            await WebsiteService.deleteWebsite(id);
            toast.info('Website deleted successfully.');
            fetchWebsites();
        } catch (error) {
            toast.error(error.message || 'Failed to delete website.');
        }
    };

    const convertUTCToLocal = (utcDateString) => {
        if (!utcDateString) return 'N/A'; // Handle null or undefined cases
        const localDate = new Date(utcDateString);
        return localDate.toLocaleString(); // Formats the date and time to the local timezone
    };

    return (
        <div className="table-responsive">
            <div className="mb-3">
                <strong>Total Websites: {totalWebsites}</strong>
            </div>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <table className="table table-striped table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>URL</th>
                            <th>Tech</th>
                            <th>Created At</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {websites.map((website, index) => (
                            <tr key={website.id}>
                                <td>{index + 1 + currentPage * size}</td>
                                <td>{website.name}</td>
                                <td>
                                    <a href={website.url} target="_blank" rel="noopener noreferrer">
                                        {website.url}
                                    </a>
                                </td>
                                <td>{website.tech}</td>
                                <td>{convertUTCToLocal(website.createdAt)}</td>
                                <td>
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-light btn-sm dropdown-toggle"
                                            type="button"
                                            id={`dropdownMenuButton${website.id}`}
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            disabled={loginUser.role==='EXECUTIVE'}
                                        >
                                            <i className="fa fa-ellipsis"></i>
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton${website.id}`}>
                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    onClick={() => {
                                                        setSelectedWebsite(website);
                                                        setShowEditModal(true);
                                                    }}
                                                >
                                                    Edit
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className="dropdown-item text-danger"
                                                    onClick={() => handleDelete(website.id)}
                                                    disabled={loginUser.role!=='ADMIN'}
                                                >
                                                    Delete
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    disabled={loginUser.role!=='ADMIN'}
                                                    onClick={() => navigator.clipboard.writeText(website.id)}
                                                >
                                                    Copy ID
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {totalPages > 1 && (
                <PaginationComponent
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(pageNumber) => setCurrentPage(pageNumber)}
                />
            )}
            {showEditModal && (
                <AddWebsiteModal
                    website={selectedWebsite}
                    onClose={() => {
                        setShowEditModal(false);
                        fetchWebsites();
                    }}
                />
            )}
        </div>
    );
};

export default WebsiteTable;
